import { combineReducers } from 'redux';

import { AddressReducer } from './address/reducer';
import { AddressState } from './address/type';
import { userChannel, UserChannelState } from './channel/reducer';
import { ChatReducer } from './chatmedicalmanage/reducer';
import { ChatState } from './chatmedicalmanage/type';
import { ClinicReducer} from './clinic/reducer';
import { ClinicState } from './clinic/type';
import { ConfigReducer } from './config/reducer';
import { ConfigState } from './config/type';
import { CouponReducer } from './coupon/reducer';
import { CouponState } from './coupon/type';
import { DepartmentReducer } from './department/reducer';
import { DepartmentState } from './department/type';
import { DictionaryReducer } from './dictionary/reducer';
import { DictionaryState } from './dictionary/type';
import { DoctorReducer } from './doctor/reducer';
import { DoctorState } from './doctor/type';
import { FamilyDoctorReducer } from './familydoctor/reducer';
import { FamilyDoctorState } from './familydoctor/type';
import { ImsState } from './im/action';
import { ImsReducer } from './im/reducer';
import { InquiryReducer } from './inquiry/reducer';
import { InquiryState } from './inquiry/type';
import { MassageTherapyReducer } from './massageTherapy/reducer';
import { MassageTherapyState } from './massageTherapy/type';
import { MedicineReducer} from './medicine/reducer';
import { MedicineState } from './medicine/type';
import { OrderReducer } from './order/reducer';
import { OrderState } from './order/type';
import { PatientsReducer } from './patients/reducer';
import { PatientsState } from './patients/type';
import { PrescriptionReducer } from './prescription/reducer';
import { PrescriptionState } from './prescription/type';
import { policyVasDetail, PolicyVasDetailState } from './right/reducer';
import { ServiceReducer } from './service/reducer';
import { ServiceState } from './service/type';
import { ServpackReducer } from './servpack/reducer';
import { ServpackState } from './servpack/type';
import { SpecialistReducer } from './specialist/reducer';
import { SpecialistState } from './specialist/type';
import { SugarBloodReducer } from './sugarblood/reducer';
import { SugarBloodState } from './sugarblood/type';
import { VideoState } from './video/action';
import { VideoReducer } from './video/reducer';

// import physicalReducer, { AppointState } from 'subPackages/szPhysical/store/physical/reducer';
import physicalReducer from 'subPackages/szPhysical/store/physical/reducer';
import type {AppointState} from 'subPackages/szPhysical/store/physical/type'
export interface ApplicationState {
  chat: ChatState;
  order: OrderState;
  videos: VideoState;
  config: ConfigState;
  doctor: DoctorState;
  coupon: CouponState;
  service: ServiceState;
  address: AddressState;
  inquiry: InquiryState;
  servpack: ServpackState;
  patients: PatientsState;
  sugarblood: SugarBloodState;
  department: DepartmentState;
  dictionary: DictionaryState;
  prescription: PrescriptionState;
  policyVasDetail: PolicyVasDetailState;
  userChannel: UserChannelState;
  ims: ImsState;
  specialists: SpecialistState;
  massageTherapy: MassageTherapyState;
  familyDoctor: FamilyDoctorState;
  clinic: ClinicState;
  medicine: MedicineState;
  physical: AppointState;
}

export const rootReducer = combineReducers<ApplicationState>({
  chat: ChatReducer,
  order: OrderReducer,
  videos: VideoReducer,
  config: ConfigReducer,
  doctor: DoctorReducer,
  coupon: CouponReducer,
  service: ServiceReducer,
  inquiry: InquiryReducer,
  address: AddressReducer,
  servpack: ServpackReducer,
  patients: PatientsReducer,
  sugarblood: SugarBloodReducer,
  department: DepartmentReducer,
  dictionary: DictionaryReducer,
  prescription: PrescriptionReducer,
  policyVasDetail,
  userChannel,
  ims: ImsReducer,
  specialists: SpecialistReducer,
  massageTherapy: MassageTherapyReducer,
  familyDoctor: FamilyDoctorReducer,
  clinic: ClinicReducer,
  medicine: MedicineReducer,
  physical: physicalReducer,
});
